function normalizePublicUrl(value: string | undefined): string | null {
  const candidate = value?.trim();
  if (!candidate) {
    return null;
  }

  try {
    const url = new URL(candidate);
    const isLoopbackHostname =
      url.hostname === "localhost" ||
      url.hostname.endsWith(".localhost") ||
      /^127(?:\.\d{1,3}){3}$/u.test(url.hostname) ||
      url.hostname === "[::1]" ||
      url.hostname === "::1";

    return url.protocol === "https:" || (url.protocol === "http:" && isLoopbackHostname)
      ? url.origin
      : null;
  } catch {
    return null;
  }
}

export const environment = {
  convexUrl: normalizePublicUrl(import.meta.env.VITE_CONVEX_URL),
} as const;
